import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { FutureInfoService } from '../../_services/index';
import { FormDoneService } from '../../_services/form-done.service';
import { ResourcesService } from '../../_services/resources.service';
import { DOCUMENT } from '@angular/common';
import { PageScrollService, PageScrollInstance } from 'ngx-page-scroll';
import { FileService } from '../../_services/file.service';
import { DashboardService } from '../../_services/dashboard.service';
import {APP_CONFIG, IAppConfig} from '../../app.config';
import { StudentOpportunityService } from '../../_services/student-opportunity.service';
import { StudentResourceService } from '../../_services/student-resource.service'
import { StudentChecklistService } from '../../_services/index';
import { ICarouselConfig, AnimationConfig } from 'angular4-carousel';
import { FlexQuestionsService } from '../../_services/flex-questions.service';

@Component({
  selector: 'app-student-new-dashboard',
  templateUrl: './student-new-dashboard.component.html',
  styleUrls: ['./student-new-dashboard.component.css'],
  providers: [FlexQuestionsService,FutureInfoService, FormDoneService, FileService,DashboardService,StudentOpportunityService,StudentResourceService,StudentChecklistService,ResourcesService]

})
export class StudentNewDashboardComponent implements OnInit {

  public currentUser: any;
  public currentUserName: any;
  public getdataSub: Subscription;
  public pendingForm;
  public resumeEditForm;
  public color = 'accent';
  public mode = 'determinate';
  public completed = 0;
  public pending;
  public strokewidth = 15;
  public imgHeight;
  public imgwidth;
  public fileuploadSub: Subscription;
  public filepath;
  public loading: boolean;
  public fileSub: Subscription;
  successMessage: string;
  errorFlag = false;
  submitting = false;
  error = false;
  Application_available = [];
  Application_notstarted = [];
  Application_started = [];
  Application_completed = [];
  Application_review = [];
  Application_granted = [];
  Application_notgranted = [];
  domainname;
  @ViewChild('container')
  private container: ElementRef;
  todolist = [];
  academicmajor;
  professionalgoal;
  first_school_code;
  second_school_code;
  third_school_code;
  fourth_school_code;
  fifth_school_code;
  sixth_school_code;
  seventh_school_code;
  eighth_school_code;
  ninth_school_code;
  tenth_school_code;
  showless = true;
  multi = [];
  view: any[] = [350, 105];
  tabCheck;
  // options
  showXAxis = false;
  showYAxis = false;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = 'SCHOLARSHIP';
  showYAxisLabel = false;
  yAxisLabel = 'PROGRESS';
  awardedAmount = 0;
  colorScheme = {
    domain: ['#A2E15F', '#FD7544','#F1EB4E']
  };
  oppertunities;
  resources;
  roadmaps;
  groupname;
  groupsid;
  showloader_opp = false;
  showloader_res = false;
  showloader_road = false;

  constructor(@Inject(APP_CONFIG) private config: IAppConfig,
  private router: Router,
  private activatedRoute: ActivatedRoute,
  private api: FutureInfoService,
  private formapi: FormDoneService,
  private flexapi: FlexQuestionsService,
  private pageScrollService: PageScrollService,
  @Inject(DOCUMENT) private document: any,
  private _fileService: FileService,
  private _DashboardService:DashboardService,
  private srs:StudentOpportunityService,
  private resApi:StudentResourceService,
  private taskApi:StudentChecklistService,
  private resserApi:ResourcesService)
  {

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    //console.log(this.currentUser.firstname);
    this.currentUserName = this.currentUser.firstname + ' ' + this.currentUser.lastname;
    //Object.assign(this, {this.single, multi})

    const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.bodyWrapper');
    this.pageScrollService.start(pageScrollInstance);

  }

  ngOnInit() {
    this.domainname = this.config.domainname;
    this.handleUserUpdated();

    const element1 = document.querySelector('.droppable');
    this.makeDroppable(element1, this.callback, this);
    this.getApplications();
    this.getTodoList();
    this.getCareerGoal();
    this.getCollagesApplied();
    this.getLatestOpportunityById();
    this.getLatestResourseById();
    this.getLatestTasks();
  }

  handleUserUpdated() {
    this.flexapi.getCompletionStatus().then(
      (success)=>{
        this.completed = Math.round(success.pctcomplete);
        // if(success.firstincomplete===null) {
        //   this.pendingForm = '/profile/'+success.firstsection.replace(/[^A-Za-z0-9]/g,'-').replace(/(-)+/g,'-').replace(/(^-|-$)/g,'').toLowerCase();
        //   this.resumeEditForm = 'Edit';
        // } else if(success.firstincomplete!==null) {
        //   this.pendingForm = '/profile/'+success.firstincomplete.replace(/[^A-Za-z0-9]/g,'-').replace(/(-)+/g,'-').replace(/(^-|-$)/g,'').toLowerCase();
        //   this.resumeEditForm = 'Resume';
        // } else{
        //   this.pendingForm = '';
        //   this.resumeEditForm = 'Resume';
        // }
      },
      (failure)=>{
        console.log(failure);
      }
    );
  }

  makeDroppable(element, callback, classObj) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);
    element.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.add('dragover');
    });

    element.addEventListener('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.remove('dragover');
    });

    element.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.remove('dragover');
        triggerCallback(e, classObj);
    });

    element.addEventListener('click', function() {
        input.value = null;
        input.click();
    });

    function triggerCallback(e, obj) {
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        callback.call(null, files, e, obj);
    }
  }

  callback(files, event, classobject?: any) {
    classobject.loading = true;
    for (let i = 0; i < files.length; i++) {
      let ext = '';
      const mimeType = files[i].type;
      ext = files[i].name.split('.').pop();
      const allowedMIMEType = ['image/jpeg', 'image/png'];
      if (allowedMIMEType.indexOf(mimeType) >= 0 ) {
        if ((allowedMIMEType.indexOf(mimeType) === 0) || (allowedMIMEType.indexOf(mimeType) === 1) ) {
          classobject.filetype = ext;
        }else {
          classobject.filetype = ext;
        }
        const body = {
          attachableId: '',
          file: files[i],
          attachableType: 'Profilepic'
        };
        const file = files[i];
        const img = new Image();
        img.src = window.URL.createObjectURL( file );
        img.onload = function() {
          classobject.imgWidth = img.naturalWidth,
          classobject.imgHeight = img.naturalHeight;
          window.URL.revokeObjectURL( img.src );
          if (
            (classobject.imgWidth <= '580') &&
            (classobject.imgHeight <= '580') &&
            (classobject.imgWidth >= '200') &&
            (classobject.imgHeight >= '200')) {
              classobject.fileuploadSub = classobject._fileService.uploadFile(body).subscribe(
                responsedata => {
                  const filelink = JSON.parse(responsedata._body).data.filelink;
                  classobject.filepath = filelink;
                  classobject.loading = false;
                }, error => {
                  classobject.loading = false;
              });
            } else {
              alert('Image should be of dimensions between 200x200 to 580x580 or less');
            }
        };
      } else {
        alert('File not allowed');
        classobject.loading = false;
      }
    }

  }

  getApplications() {
    this.loading = true;
    this.submitting = true;
    this.fileSub = this._fileService.getApplications$()
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        const response = data;
        console.log(data.data);
        this.Application_available = data.data.notapplied;
        this.Application_notstarted = data.data.applied.notstarted;
        this.Application_started = data.data.applied.started;
        this.Application_completed = data.data.applied.completed;
        this.Application_review = data.data.applied.review;
        this.Application_granted = data.data.applied.granted;
        if(data.data.applied.awardedAmount){
          this.awardedAmount = data.data.applied.awardedAmount;

        }
        this.Application_notgranted = data.data.applied.notgranted;
        console.log(this.Application_granted);
        //console.log(this.Application_notgranted.length);
        //console.log(this.Application_review.length);
        //let Scholarship = [];

        this.multi =
        [
          {
            name: "Scholarship",
            series:[
                {
                  name: 'Awarded',
                  value: this.Application_granted.length,
                },
                {
                  name: "Not Awarded",
                  value: this.Application_notgranted.length
                },
                {
                  name: "In Review",
                  value: this.Application_review.length
                }
            ]
          }
        ];

      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        this.loading = false;
      },
    );
  }

  getTodoList() {
    this.loading = true;
    this.submitting = true;
    this._DashboardService.getTodoList$()
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        const response = data;
        if(data.data.todo.length>0)
        {
          this.todolist = data.data.todo;
        }

      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        this.loading = false;
      },
    );
  }


  getCollagesApplied() {
    this.loading = true;
    this.submitting = true;
    this._DashboardService.getCollagesApplied$()
    .subscribe(
      data => {

        this.first_school_code = data.data.first_school_code;
        this.second_school_code = data.data.second_school_code;
        this.third_school_code = data.data.third_school_code;
        this.fourth_school_code = data.data.fourth_school_code;
        this.fifth_school_code = data.data.fifth_school_code;
        this.sixth_school_code = data.data.sixth_school_code;
        this.seventh_school_code = data.data.seventh_school_code;
        this.eighth_school_code = data.data.eighth_school_code;
        this.ninth_school_code = data.data.ninth_school_code;
        this.tenth_school_code = data.data.tenth_school_code;
        //console.log(data.data.first_school_code);
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        this.loading = false;
      },
    );
  }

  getCareerGoal() {
    this.loading = true;
    this.submitting = true;
    this._DashboardService.getCareerGoal$()
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        const response = data;
        console.log(response);
        this.academicmajor = response.data.academicmajor_id;
        this.professionalgoal = response.data.professionalgoals_id;

        /* if(data.data.todo.length>0)
        {
          this.todolist = data.data.todo;
        } */

      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        this.loading = false;
      },
    );
  }

  showMore(){
    if(this.showless)
    {
      this.showless = false;
    }
    else{
      this.showless = true;
    }
  }

  getLatestOpportunityById()
  {

    this.showloader_opp = true;
     this.srs.getfouropportunities().subscribe(res=>{
      console.log(res.data);
      this.oppertunities = res.data;
      this.showloader_opp = false;
    })
    this.showloader_opp = false;
  }

  getLatestResourseById()
  {
    this.showloader_res = true;

    this.resApi.getLatestResources().subscribe(res=>{
      console.log(res.data);
      this.resources = res.data;
      this.showloader_res = false;
    })
    this.showloader_res = false;
  }

  getLatestTasks()
  {
    this.showloader_road = true;
    this.resserApi.resourcesListbyid(this.currentUser.personid).subscribe(res=>{
      this.roadmaps = res.data;
      if(res.status == 1){
        this.groupname = res.data.name;
        this.groupsid = res.data.id;
        this.showloader_road = false;
      }
      this.showloader_road = false;
    })
  }

  ngOnDestroy() {

    if (this.fileSub)  {
      this.fileSub.unsubscribe();
    }
    if (this.fileuploadSub) {
      this.fileuploadSub.unsubscribe();
    }
    if (this.getdataSub) {
      this.getdataSub.unsubscribe();
    }
  }

  public imageSources: string[] = [
    'assets/img/ad-new.png',
    'assets/img/Desert_Healthcare_District.png',
  ];

  public configslide: ICarouselConfig = {
    verifyBeforeLoad: true,
    log: false,
    animation: true,
    animationType: AnimationConfig.SLIDE,
    autoplay: true,
    autoplayDelay: 5000,
    stopAutoplayMinWidth: 768
  };

  openTab(tabname){
    console.log(this.tabCheck);
    console.log(tabname);
    if(this.tabCheck != tabname){
      this.tabCheck =tabname;
    }
    else{
      this.tabCheck = '';
    }


  }


}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-new-dashboard/student-new-dashboard.component.ts